import React, { useMemo } from 'react';
import { SmartSelect, type SmartSelectOption } from '../dropdown';
import type { TaskListDefinition } from '@techgitter/contracts';

interface TaskListPickerProps {
  availableLists: TaskListDefinition[];
  isLoading: boolean;
  onAttach: (taskListDef: TaskListDefinition) => void;
  disabled?: boolean;
}

export const TaskListPicker: React.FC<TaskListPickerProps> = ({
  availableLists,
  isLoading,
  onAttach,
  disabled,
}) => {
  const options = useMemo<SmartSelectOption[]>(
    () => availableLists.map((l) => ({ value: l.taskListId, label: l.displayName })),
    [availableLists],
  );

  if (availableLists.length === 0 && !isLoading) {
    return null;
  }

  // Acts as an "attach" trigger: value stays null so the trigger always shows
  // the placeholder; selecting a list fires onAttach and resets.
  return (
    <SmartSelect
      label="Task List"
      value={null}
      placeholder="Attach a task list…"
      options={options}
      disabled={disabled}
      onChange={(value) => {
        const def = availableLists.find((l) => l.taskListId === value);
        if (def) onAttach(def);
      }}
      renderItem={(option) => {
        const def = availableLists.find((l) => l.taskListId === option.value);
        return (
          <span style={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1, minWidth: 0 }}>
            <span className="sm4rt-dd__item-code">{option.label}</span>
            {def?.description ? (
              <span className="sm4rt-dd__item-desc">{def.description}</span>
            ) : null}
          </span>
        );
      }}
    />
  );
};
